import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2, Sparkles, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  if (user) {
    const to = location.state?.from?.pathname || "/admin";
    return <Navigate to={to} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Bienvenue.");
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail || err?.message || "Identifiants invalides.";
      toast.error(typeof detail === "string" ? detail : "Connexion impossible.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6] px-6">
      <div className="w-full max-w-md bg-white border border-[#EAE8E3] p-10">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-full bg-[#96836B] flex items-center justify-center">
            <Sparkles className="h-4 w-4 text-white" strokeWidth={1.5} />
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.22em] text-[#96836B]">Espace conseiller</p>
            <h1 className="font-serif-display text-2xl mt-1">Deal Travel</h1>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="email" className="label-eyebrow">Email</Label>
            <Input
              id="email"
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="luxury-input"
              placeholder="vous@dealtravel.eu"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password" className="label-eyebrow">Mot de passe</Label>
            <div className="relative">
              <Input
                id="password"
                data-testid="login-password"
                type={show ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="luxury-input pr-10"
                autoComplete="current-password"
              />
              <button
                type="button"
                onClick={() => setShow((s) => !s)}
                className="absolute right-2 top-2 p-1 text-[#737373] hover:text-[#1A1B18]"
                tabIndex={-1}
                aria-label={show ? "Cacher le mot de passe" : "Afficher le mot de passe"}
              >
                {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
              </button>
            </div>
          </div>
          <Button
            type="submit"
            data-testid="login-submit"
            disabled={loading}
            className="w-full rounded-none bg-[#1A1B18] hover:bg-[#96836B] text-white py-6 text-[11px] uppercase tracking-[0.28em] transition-colors"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Se connecter"}
          </Button>
        </form>
      </div>
    </div>
  );
}
